/**
 * 🔴 A page chunk that no longer exists after a deploy (owner 2026-10-17: "sometimes when I move
 * from one page to another the page is just white and black, only once I reload it loads").
 *
 * Every deploy renames the hashed chunk files. A tab opened before it still asks for the OLD
 * names when it navigates; the import fails, React.lazy has nothing to render, and the screen is
 * blank until a manual reload fetches the new index.html. So a failed chunk import reloads the
 * page — once per 30 seconds, so a chunk that is genuinely broken shows its error instead of
 * reloading for ever.
 */
const KEY = "relay-chunk-reload-at";
const WINDOW_MS = 30_000;

function reloadOnce(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < WINDOW_MS) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* storage blocked: still reload; worst case the browser repeats it, which is the old blank */
  }
  window.location.reload();
  return true;
}

/** `.catch(reloadOnChunkError)` on a lazy import: reloads (and never settles) or rethrows. */
export function reloadOnChunkError(err: unknown): Promise<never> {
  if (reloadOnce()) return new Promise<never>(() => {});
  throw err;
}

// Vite's own signal for a failed preload of a chunk's dependencies (CSS / shared chunks).
window.addEventListener("vite:preloadError", (event) => {
  if (reloadOnce()) event.preventDefault();
});
